import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImpressumPage } from './Impressum';
import { ComponentsModule } from "../../components/components.module"

@NgModule({
  declarations: [
    ImpressumPage,
  ],
  imports: [
    IonicPageModule.forChild(ImpressumPage),
	ComponentsModule
  ],
})
export class ImpressumPageModule {}



// WEBPACK FOOTER //
// ./src/pages/Impressum/Impressum.module.ts